import styles from './Logo.module.css';
// Inlined as SVG elements rather than <img src>: the mobile menu mounts a
// second copy of the logo when it opens, and an <img> re-hits the network
// cache on mount, which flashed an empty box for a frame or two.
import { ReactComponent as LogoLight } from '../../logo.svg';
import { ReactComponent as LogoDark } from '../../logo-dark.svg';

function Logo({ height = 36 }) {
  // width: auto lets each SVG keep its own aspect ratio from the viewBox.
  const size = { height, width: 'auto' };

  return (
    <>
      <LogoLight
        className={styles.lightLogo}
        style={size}
        role="img"
        aria-label="POW"
      />
      <LogoDark
        className={styles.darkLogo}
        style={size}
        role="img"
        aria-label="POW"
      />
    </>
  );
}

export default Logo;
